import { useContext } from "react";
import useSWRMutation from "swr/mutation";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";
import { CommentPartModel } from "@attelas/shared";

export const useAddComment = (externalId?: string | null) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { trigger, isMutating, error } = useSWRMutation(
    externalId ? `${environment.apiUrl}/api/emails/actions/${externalId}/comment` : undefined,
    (url: string, { arg }: { arg: { comment: CommentPartModel[] } }) =>
      fetcher<{ result: string }>(url, {
        method: "POST",
        body: JSON.stringify(arg),
      }),
    {
      onError: () => {
        showToast("Failed to add comment, please try again later", "error");
      },
    }
  );

  return {
    addComment: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
